import { Length } from "@pdfking/tfunc"

import type { SidebarViewProps } from "#public"

import { ContentControl } from "../components/ContentControl"
import { FileRows } from "../components/FileRows"
import { PanelInformations } from "../components/PanelInformations"
import { useTranslationTyped } from "../i18n/useTranslation"

// Upload and assignment unified: one row per `file_key` entry, the file (or
// its upload cell, for a blank row) and the fields that assign it (range,
// destination, scale) side by side — see FileRows. With no file the pages are
// generated, and staff pick what they are drawn as under the upload.
export function FilesView({
  content,
  debug,
  fields,
  files_node,
  hidden_fields,
  informations,
  on_content,
  on_files,
  page_counts,
  sheet_math,
  store,
  view,
}: SidebarViewProps) {
  const panels = useTranslationTyped("filecheck")
  const pdfview = useTranslationTyped("pdfview")
  return (
    <div className="flex flex-1 flex-col gap-2 px-2">
      {/* What the panel is for, above the rows — the copy the legacy modal
          carried in its own sidebar header (filecheck.tsx on master, where it
          was staff-hidden; here it stays for everyone, since the panel no
          longer doubles as the imposition form). */}
      <dl className="m-0 px-1 text-sm">
        <dt className="font-medium">{panels.DOWNLOAD_TEMPLATE()}</dt>
        <dd className="ms-3 text-muted-foreground">{pdfview.TEMPLATE_FEATURE_1()}</dd>
        <dd className="ms-3 mb-2 text-muted-foreground">{pdfview.TEMPLATE_FEATURE_2()}</dd>
        <dt className="font-medium">{panels.CHECK_YOUR_FILE()}</dt>
        <dd className="ms-3 text-muted-foreground">{pdfview.TEMPLATE_FEATURE_3()}</dd>
        <dd className="ms-3 text-muted-foreground">{pdfview.TEMPLATE_FEATURE_4()}</dd>
      </dl>
      {files_node && (
        <FileRows
          view={view}
          hidden_fields={hidden_fields}
          node={files_node}
          on_files={on_files}
          staff={true}
          store={store}
        />
      )}
      {debug && Length(store.files) === 0 && (
        <ContentControl on_value={on_content} value={content} />
      )}
      <PanelInformations
        fields={fields}
        informations={informations}
        page_counts={page_counts}
        sheet_math={sheet_math}
        store={store}
      />
    </div>
  )
}
